import { WhoAmI } from 'containers/Auth_old/selectors';

export const canViewConversations = (whoami?: WhoAmI | null): boolean =>
  whoami?.policies?.view_reports === true;
